// @flow

import React from "react";
import { Section, Card } from "buba-components";
import cx from "classnames";
import sharedStyles from "../DashboardSummary/shared/Shared.scss";
import inquiryCreatorStyles from "./InquiryCreatorDetails.scss";
import LabeledContent from "../DashboardSummary/LabeledContent";

type InquiryCreatorDetailProps = {
  inquiryCreator: {
    firstName: String,
    lastName: String,
    id: String,
    phoneNumber: String,
    email: String
  },
  bank: {
    name: String
  }
};

const InquiryCreatorDetails = ({ inquiryCreator, bank }: InquiryCreatorDetailProps) => {
  return (
    <Section reducedMargin>
      <Card>
        {inquiryCreator?.id && (
          <>
            <p className={inquiryCreatorStyles.title}>Anfragesteller</p>
            <div
              className={cx(sharedStyles.container, inquiryCreatorStyles.container)}
              data-testid="inquirysummary"
            >
              <div className={sharedStyles.row}>
                <div className={sharedStyles.col}>
                  <LabeledContent
                    additionalContentStyles={inquiryCreatorStyles.labeledContent}
                    label="BANK"
                  >
                    {bank.name}
                  </LabeledContent>
                </div>
              </div>
              <div className={sharedStyles.row}>
                <div className={sharedStyles.col}>
                  <LabeledContent
                    additionalContentStyles={inquiryCreatorStyles.labeledContent}
                    label="ANSPRECHPARTNER"
                  >
                    {`${inquiryCreator.firstName} ${inquiryCreator.lastName}`}
                  </LabeledContent>
                </div>
              </div>
              <div className={sharedStyles.row}>
                <div className={sharedStyles.col}>
                  <LabeledContent
                    additionalContentStyles={inquiryCreatorStyles.labeledContent}
                    label="TELEFON"
                  >
                    {inquiryCreator.phoneNumber}
                  </LabeledContent>
                </div>
              </div>
              <div className={sharedStyles.row}>
                <div className={sharedStyles.col}>
                  <LabeledContent
                    additionalContentStyles={inquiryCreatorStyles.labeledContent}
                    label="MAIL"
                  >
                    {inquiryCreator.email}
                  </LabeledContent>
                </div>
              </div>
            </div>
          </>
        )}
      </Card>
    </Section>
  );
};

export default InquiryCreatorDetails;
